import ReactDOM from 'react-dom';
import App from './containers/App.js';
import './index.css';


ReactDOM.render(<App />, document.getElementById("root"));